import { Title } from '@/components/Typography';

export const TitleElement = ({ text, tag }: { text: string; tag?: string }) => {
  return (
    <Title className="pt-2.5 lg:pb-7.5 md:pb-5 sm:pb-5 intro-title" tag={tag || 'div'} type="md">
      {text}
    </Title>
  );
};
